var map = {
	"./afb-color.svg": 1793,
	"./afb.svg": 1794,
	"./alb-color.svg": 1795,
	"./alb.svg": 1796,
	"./amb-color.svg": 1797,
	"./amb.svg": 1798,
	"./bbbaidja-color.svg": 1799,
	"./bbbaidjaxxx-color.svg": 1800,
	"./bdinidjaxxx-color.svg": 1801,
	"./bimb-color.svg": 1802,
	"./bimb.svg": 1803,
	"./bkr-color.svg": 1804,
	"./bkr.svg": 1805,
	"./bmriidja-color.svg": 1806,
	"./bniaidja-color.svg": 1807,
	"./bninidja-color.svg": 1808,
	"./bninidjaxxx-color.svg": 1809,
	"./bpay-color.svg": 1810,
	"./brinidja002-color.svg": 1811,
	"./bsmdidjaxxx-color.svg": 1812,
	"./bsn-color.svg": 1813,
	"./bsn.svg": 1814,
	"./btanidjaxxx-color.svg": 1815,
	"./cenaidja-color.svg": 1816,
	"./cenaidjaxxx-color.svg": 1817,
	"./cimb-color.svg": 1818,
	"./cimb.svg": 1819,
	"./citi-color.svg": 1820,
	"./citi.svg": 1821,
	"./default-bank-icon-color.png": 1822,
	"./default-bank-icon.png": 1823,
	"./gxbank-color.svg": 1824,
	"./hlb-color.svg": 1825,
	"./hlb.svg": 1826,
	"./hsbc-color.svg": 1827,
	"./hsbc.svg": 1828,
	"./ibbkidjaxxx-color.svg": 1829,
	"./kwh-color.svg": 1830,
	"./kwh.svg": 1831,
	"./mbb-color.svg": 1832,
	"./mbb.svg": 1833,
	"./nispidjaxxx-color.svg": 1834,
	"./ocbc-color.svg": 1835,
	"./ocbc.svg": 1836,
	"./pbb-color.svg": 1837,
	"./pbb.svg": 1838,
	"./pinbidja-color.svg": 1839,
	"./rhb-b.svg": 1840,
	"./rhb-color-b.svg": 1841,
	"./rhb-color.svg": 1842,
	"./rhb.svg": 1843,
	"./scb-color.svg": 1844,
	"./scb.svg": 1845,
	"./tng-color.svg": 1846,
	"./uob-color.svg": 1847,
	"./uob.svg": 1848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;